$(document).ready(function () {
    $("#zip-pay-popup").click(function (e) {
      $.fancybox([
  {
    content: `<iframe id="iframe1" name="iframe1" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" scrolling="auto" data-ready="1"></iframe>`,
    type: 'html',
    afterShow: function(instance, current) {
      const iframe = document.getElementById('iframe1');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(`
          <html><head><script type="text/javascript" crossorigin="anonymous" src="https://bpi.zip.co/assets/js/amplitude-8.16.1-min.gz.js"><\/script>
          <script src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/zip-modal-script.js"><\/script>
          <script src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"><\/script>
          <script src="https://bpi.zip.co/assets/primary/resources/amplitude/amplitude-injector.js" type="text/javascript"><\/script></head><body>

    <meta charset="utf-8">
    <style>
      
      :root {
        /*Margins */
        margin-left: auto;
        margin-right: auto;
        /* Fonts */
        --weight-book: 400;
        --weight-medium: 500;
        background-color: #F6F6EE;
        overflow-x: hidden;
        width: 100%;
        height: fit-content;
      }

      html {
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none; 
      }

      html::-webkit-scrollbar { 
        display: none;  /* Safari and Chrome */
      }

      .zip-logo {
        width:62.67px;
        height:24px;
        margin-bottom: 16px;
      }
      .zp-details {
        height: 100%;
        width: 100%;
        border-color: transparent;
        display: grid;
        color: #1a0826;
      }
      .header {
        display: grid;
        margin: -1rem;
        margin-bottom: 2%;
      }
      .right {
        margin-top: 6%;
        margin-bottom: 2%;
        padding-left: 6%;
        margin-right: auto;
      }
      .pocket {
        background-color: #AA8FFF;
        position:absolute;
        right: -1rem;
        top: 0;
        height: calc(100% + 5%);
        width: calc(60%);
        clip-path: polygon(100% 100%, 60% 100%, 50% 0, 100% 0);
      }
      .hero-banner {
        position: relative;
        background-color: #1a0826;
      }
      .container {
        display: grid;
        position: relative;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 1rem; 
      }
      .left-text {
        margin: 16% 30% 10% 12%;
        width: 95%;
      }
      .left-text h3 {
        font-weight: 600;
        font-size: 38px;
        line-height: 110%;   
        color:white;
        margin:0;  
        padding-bottom: 20px;  
        font-feature-settings: 'ss01' on, 'ss02' on; 
      }
      .left-text h4 {
        font-weight: var(--weight-medium);            
        font-size: 14px;
        line-height: 130%;
        padding-bottom: 4px;
        font-style: normal;
        color:white;
        margin:0;
        position:relative;
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .left-text p {
        font-weight: var(--weight-book);            
        font-size: 14px;         
        padding-bottom: 5px;
        font-style: normal;
        color:white;
        margin:0;
        position:relative;
        display: flex;
        align-items:center;
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .left-text b {
        font-weight: var(--weight-medium);  
        font-feature-settings: 'ss01' on, 'ss02' on;          
      }
      .app-review {
        margin-top: 16px;
        font-size: 12px;
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      #translations-main,
      .trustpilot-widget {
        right: 1.5rem;
        font-weight: var(--weight-book); 
        font-size: 12px !important;    
        margin: 0;     
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .right {
        margin-top: 6%;
        margin-bottom: 2%;
        padding-left: 20%;
        margin-right: auto;
      }
      .zp-content {
        padding-left: 4%;
        margin-top: 4%;
      }
      .zp-list li {
        background-image: url("https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/bullet-points.svg");
        font-weight: var(--weight-book);
        background-repeat: no-repeat;
        padding-inline-start: 40px;
        display: inline-block;
        font-size: 12px;
        line-height: 150%;
        margin-block-end: 16px;
        list-style-position: outside;
        width: 100%;
        color: #1A0826;
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .zp-list b {
        font-weight: var(--weight-medium);
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .button-container {
        display: flex;
        padding-top: 2%;
        padding-bottom: 2%;
      }
      .button {
        width: 162px;
        height: 44px;
        background-color: rgba(65, 19, 97, 1);
        color: rgba(255, 255, 250, 1);
        font-weight: var(--weight-medium);
        font-size: 16px;
        line-height: 150%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-color: transparent;
        border-radius: 8px;
        text-decoration:none;
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .section-zip-disclaimer {
        padding: 2% 4% 4% 4%;

        border-color: transparent;
        color: #786E7A;
      }
      .disclaimer-content {
        display: flex;
        font-weight: var(--weight-book);
        font-size: 9px;
        line-height: 140%;
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .hidden {
        display: none !important;
      } 

      @media screen and (min-width: 145px) {
        .tp-widget-rating, .tp-widget-logo {
          font-weight: var(--weight-book); 
          font-size: 12px !important;    
          font-feature-settings: 'ss01' on, 'ss02' on;
          margin: 0px;
          margin-left: -1px;        
        }
      }     

      @media (max-device-width: 640px) { /* MOBILE */
        .pocket {
          height: calc(100% + 5%);
          width: calc(40%);
          clip-path: polygon(100% 100%, 80% 100%, 50% 0, 100% 0);
        }
        .container {
          display: grid;
          position: relative;
          grid-template-columns: repeat(1, 1fr);
          grid-gap: 1rem; 
        }
        .left-text {
          margin: 14% 20% 14% 8%;
          width: 76%;
        }
        .left-text h3 {
          font-size: 34px;
        }
        .left-text h4,
        .left-text p {
          font-size: 16px;
        }
        .app-review {
          font-size: 13px;
        }
        .zp-content {
          padding-top: 6%;
        }
        .zp-list li {
          width: 90%;
          font-size: 16px;
        }
        .button-container {
          padding-top: 4%;
          padding-bottom: 4%;
        }
        .button {
          width: 312px;
          height: 44px;
        }
        .disclaimer-content {
          font-size: 11px;
        }
        .right {
          display: none;
        }
      }
      </style>    

    <section class="header">
      <div class="hero-banner">
        <div class="pocket"></div>
        <div class="container">
          <div class="left-text">
            <img class="zip-logo" src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/zip-logo.svg" alt="Zip Logo">
            <h3>The better way to pay</h3>
            <h4>ZIP PAY</h4>
            <p>Make it easier to pay for everyday purchases</p>
            <div class="app-review">
              <p><b>4.9</b>
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-left: 4px; padding-right: 4px;">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px;">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px;">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px;">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px;">
                App store rating</p>
            </div>
            <div class="trustpilot-widget" data-locale="en-AU" data-template-id="5419b6a8b0d04a076446a9ad" data-businessunit-id="58dc03a40000ff00059f77a2" data-style-height="24px" data-theme="dark" style="position: relative;"><iframe title="Customer reviews powered by Trustpilot" loading="auto" src="https://widget.trustpilot.com/trustboxes/5419b6a8b0d04a076446a9ad/index.html?templateId=5419b6a8b0d04a076446a9ad&amp;businessunitId=58dc03a40000ff00059f77a2#locale=en-AU&amp;styleHeight=24px&amp;theme=dark" style="position: relative; height: 24px; border-style: none; display: block; overflow: hidden;"></iframe></div>
          </div>
          <div class="right">
            <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/device2.png" width="182" height="338">
          </div>
        </div>
      </div> 
    </section>
    <section class="zp-content">
      <div class="zp-list">
          <li>Spend up to <b>$1,000</b></li>
          <li>Pay <b>nothing today</b></li>
          <li>Always <b>interest free*</b></li>
          <li><b>Spread repayments</b> over a month or longer</li>
          <li><b data-monthly-fee="monthly-fee">$9.95/mth</b> account fee or $0 if nothing owing </li>
          <span class="button-container">
            <a class="button" href="https://start.zip.co/send-m-code?m=%7BMerchantPublicId%7D&amp;utm_source=merchant&amp;utm_medium=web&amp;utm_campaign=hosted_bpi&amp;utm_content=zp_modal&amp;amp_user_id=973d8a5b-fe61-4108-a6a2-e7d07007e468&amp;amp_device_id=czRIJ_C6eSXVjLoV7P-PIZ&amp;amp_user_id=5f74d63d-9374-473d-b9ce-ca7dbbe21cc5&amp;amp_device_id=czRIJ_C6eSXVjLoV7P-PIZ" target="_blank">Apply Now</a>
          </span>
    </div>
    </section>
    <section class="section-zip-disclaimer">
      <span class="disclaimer-content">
        <p>
          *Available to approved applicants only and subject to completion of satisfactory credit check. 
          Minimum monthly repayments are required. Other charges may be payable. T&amp;Cs apply.
        </p>
      </span>
    </section>
    <img id="helper" class="hidden" src="null" data-amp-page="zip_merchant_modal_zip_pay" onerror="var script=document.createElement('script');script.src='https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/zip-modal-script.js';document.head.appendChild(script);
      var trustpilotWidgetScript=document.createElement('script');trustpilotWidgetScript.src='https\:\/\/widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';document.head.appendChild(trustpilotWidgetScript)">
      
</body></html>
        `);
        iframe.contentWindow.document.close();
      }
    }
  },
  {
    content: `<iframe id="iframe2" name="iframe2" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" scrolling="auto" data-ready="1"></iframe>`,
    type: 'html',
    afterShow: function(instance, current) {
      const iframe = document.getElementById('iframe2');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(`
         <html><head>
         <script type="text/javascript" crossorigin="anonymous" src="https://bpi.zip.co/assets/js/amplitude-8.16.1-min.gz.js"><\/script>
         <script src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/zip-modal-script.js"><\/script>
         <script src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"><\/script>
         <script src="https://bpi.zip.co/assets/primary/resources/amplitude/amplitude-injector.js" type="text/javascript"><\/script></head><body>


    <meta charset="utf-8">
    <style>
      @font-face {
        font-weight: 500;
        font-family: "Jug Sharp Grotesk 25";
        font-style: normal;
        src: local("Jug Sharp Grotesk 25"), local("Jug Sharp Grotesk 25");
        src: url("https://bpi.zip.co/assets/fonts/sharp-grotesk-semibold-25.woff2")
          format("woff2");
        font-display: swap;
      }

      :root {
        /*Margins */
        margin-left: auto;
        margin-right: auto;
        /* Fonts */
        --sharp-grotesk-font: Sharp Grotesk, Helvetica;
        --sharp-grotesk-font-wide: "Sharp Grotesk 25";
        --sharp-grotesk-jug: "Jug Sharp Grotesk 25";
        --weight-book: 400;
        --weight-medium: 500;
        background-color: #f6f6ee;
      }

      html {
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        scrollbar-width: none;
      }

      html::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
      }

      .zip-logo {
        width: 62.67px;
        height: 24px;
        margin-bottom: 16px;
      }
      .zp-details {
        height: 100%;
        width: 100%;
        border-color: transparent;
        display: grid;
        color: #1a0826;
      }
      .header {
        display: grid;
        margin: -1rem;
        margin-bottom: 1%;
      }
      .pocket {
        background-color: #aa8fff;
        position: absolute;
        right: 0;
        top: 0;
        height: calc(100% + 5%);
        width: calc(40%);
        clip-path: polygon(100% 100%, 80% 100%, 50% 0, 100% 0);
      }
      .hero-banner {
        position: relative;
        background-color: #1a0826;
      }
      .container {
        display: grid;
        position: relative;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 0rem;
      }
      .left-text {
        margin: 10% 30% 10% 12%;
        width: 95%;
      }
      .left-text h3 {
        font-weight: 600;
        font-size: 38px;
        line-height: 110%;
        color: white;
        margin: 0;
        padding-bottom: 20px;
        font-feature-settings: "ss01" on, "ss02" on;
      }
      .left-text p {
        font-weight: var(--weight-book);
        font-size: 14px;
        padding-bottom: 5px;
        font-style: normal;
        color: white;
        margin: 0;
        position: relative;
        display: flex;
        align-items: center;
        font-feature-settings: "ss01" on, "ss02" on;
      }
      .left-text b {
        font-weight: var(--weight-medium);
        font-feature-settings: "ss01" on, "ss02" on;
      }
      .app-review {
        margin-top: 16px;
        font-size: 12px;
      }
      #translations-main,
      .trustpilot-widget {
        right: 1.5rem;
        font-weight: var(--weight-book);
        font-size: 12px !important;
        margin: 0;
        font-feature-settings: "ss01" on, "ss02" on;
      }
      .right {
        display: none;
      }
      .zp-content {
        padding-left: 4%;
        margin-top: 4%;
        display: grid;
        position: relative;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 1rem;
      }
      .zp-list li {
        background-image: url("https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/bullet-points.svg");
        font-weight: var(--weight-book);
        background-repeat: no-repeat;
        padding-inline-start: 40px;
        display: inline-block;
        font-size: 12px;
        line-height: 150%;
        margin-block-end: 16px;
        list-style-position: outside;
        width: 90%;
        color: #1a0826;
        font-feature-settings: "ss01" on, "ss02" on;
      }
      .zp-list b {
        font-weight: var(--weight-medium);
      }
      .button-container {
        display: flex;
        padding-top: 2%;
        padding-bottom: 4%;
      }
      .button {
        width: 139px;
        height: 32px;
        background-color: rgba(65, 19, 97, 1);
        color: rgba(255, 255, 250, 1);
        font-size: 12px;
        line-height: 150%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-color: transparent;
        border-radius: 8px;
        text-decoration: none;
        font-feature-settings: "ss01" on, "ss02" on;
      }
      .section-zip-disclaimer {
        padding-top: 1%;
        padding-right: 4%;
        padding-left: 4%;
        border-color: transparent;
        color: #786e7a;
      }
      .disclaimer-content {
        display: flex;
        font-weight: var(--weight-book);
        font-size: 9px;
        line-height: 140%;
        letter-spacing: 0.4px;
        font-feature-settings: "ss01" on, "ss02" on;
      }
      .hidden {
        display: none !important;
      }

      @media screen and (min-width: 145px) {
        .tp-widget-rating,
        .tp-widget-logo {
          font-weight: var(--weight-book);
          font-size: 12px !important;
          font-feature-settings: "ss01" on, "ss02" on;
          margin: 0px;
          margin-left: -1px;
        }
      }

      @media (max-width: 640px) {
        /* MOBILE */
        .container {
          display: grid;
          position: relative;
          grid-template-columns: unset;
          grid-gap: 1rem;
          padding-block: 3rem;
          padding-left: 2rem;
        }
        .left-text {
          margin: 0;
        }
        .left-text h3 {
          font-size: 34px;
        }
        .left-text p {
          font-size: 16px;
        }
        .app-review {
          font-size: 13px;
        }
        .zp-content {
          padding-top: 6%;
          display: grid;
          position: relative;
          grid-template-columns: repeat(1, 1fr);
          grid-gap: 1rem;
        }
        .zp-list li {
          width: 90%;
          font-size: 16px;
        }
        .button-container {
          padding-top: 4%;
          padding-bottom: 4%;
        }
        .button {
          width: 162px;
          height: 44px;
          font-size: 16px;
        }
        .disclaimer-content {
          font-size: 11px;
        }
      }

      @media only screen and (min-width: 640px) {
        .right {
          display: block;
          padding-top: 1%;
          padding-left: 10%;
        }
        .pocket {
          width: calc(70%);
          clip-path: polygon(100% 100%, 60% 100%, 45% 0, 100% 0);
        }
      }
    </style>    
  
  
    <section class="header">
      <div class="hero-banner">
        <div class="pocket"></div>
        <div class="container">
          <div class="left-text">
            <img class="zip-logo" src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/zip-logo.svg" alt="Zip Logo">
            <h3>The better way to pay</h3>
            <p>Make it easier to pay for everyday purchases</p>
            <div class="app-review">
              <p>
                <b>4.9</b>
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-left: 4px; padding-right: 4px">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px">
                App store rating
              </p>
            </div>
          </div>
          <div class="right">
            <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/device2.png" width="182" height="325">
          </div>
        </div>
      </div>
    </section>
    <section class="zp-content">
      <div class="zp-list">
        <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/zip-pay-logo.svg" alt="star icon" width="197.7" height="40" style="margin-left: -22px; margin-bottom: 2%">
        <li>Spend up to <b>$1,000</b></li>
        <li>Pay <b>nothing today</b></li>
        <li>Always <b>interest free*</b></li>
        <li><b>Spread repayments</b> over a month or longer</li>
        <li>
          <b data-monthly-fee="monthly-fee">$9.95/mth</b> account fee or
          $0 if nothing owing
        </li>
        <span class="button-container">
          <a class="button" href="https://start.zip.co/send-m-code?m=%7BMerchantPublicId%7D&amp;utm_source=merchant&amp;utm_medium=web&amp;utm_campaign=hosted_bpi&amp;utm_content=zp_hybrid_modal&amp;amp_user_id=8d98beae-f7be-4bdf-8831-d9ea7183c859&amp;amp_device_id=czRIJ_C6eSXVjLoV7P-PIZ&amp;amp_user_id=0beb2f7f-cdaa-4b13-a5e5-981127a2b7a9&amp;amp_device_id=czRIJ_C6eSXVjLoV7P-PIZ" target="_blank">Apply Now</a>
        </span>
      </div>
      <div class="zp-list">
        <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/zip-money-logo.svg" alt="star icon" width="197.7" height="40" style="margin-bottom: 2%">
        <li data-max-credit="max-credit">
          Apply for <b>$1,000 - $5,000</b>
        </li>
        <li>Pay <b>nothing today</b></li>
        <li data-max-interest="max-interest">
          <b>3 - 60 months </b> interest free^
        </li>
        <li>
          <b data-monthly-fee="monthly-fee">$9.95/mth</b> account fee or
          $0 if nothing owing
        </li>
        <li><b>One off</b> establishment fee up to $99 may apply</li>
        <span class="button-container">
          <a class="button" href="https://start.zip.co/send-m-code?pp=zipMoney&amp;m=%7BMerchantPublicId%7D&amp;utm_source=merchant&amp;utm_medium=web&amp;utm_campaign=hosted_bpi&amp;utm_content=zm_hybrid_modal&amp;amp_user_id=8d98beae-f7be-4bdf-8831-d9ea7183c859&amp;amp_device_id=czRIJ_C6eSXVjLoV7P-PIZ&amp;amp_user_id=0beb2f7f-cdaa-4b13-a5e5-981127a2b7a9&amp;amp_device_id=czRIJ_C6eSXVjLoV7P-PIZ" target="_blank">Apply Now</a>
        </span>
      </div>
    </section>
    <section class="section-zip-disclaimer">
      <span class="disclaimer-content">
        <p>
          *Zip Pay. Available to approved applicants only and subject to
          completion of satisfactory credit check. Other charges may be payable.
          T&amp;Cs apply.
          <br>
          ^Zip Money. Interest free term subject to minimum spend and promotional partner offer. Available to approved applicants only and subject to completion of satisfactory credit assessment. A monthly account fee of $9.95 applies and a one off establishment fee may apply for new customers. Any balance outstanding at the expiry of the interest free period will be charged at the standard variable interest rate, 25.9% per annum, as at 1 June 2023. Other charges may be payable, see T&amp;Cs. Interest, fees and charges subject to change. Minimum monthly payments are required and vary depending on credit limit. Paying only the minimum monthly repayment may not repay a purchase within the interest free period. Paying the minimum monthly repayment may result in paying off the purchase before the interest free period expires. Credit provided by ZipMoney Payments Pty Ltd (ABN 58 164 440 993), Australian Credit Licence Number 441878. Terms &amp; Conditions apply and are available on application. See your contract for further details.
        </p>
      </span>
    </section>
    <img id="helper" class="hidden" src="null" data-amp-page="zip_merchant_modal_hybrid" onerror="var script=document.createElement('script');script.src='https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/zip-modal-script.js';document.head.appendChild(script)
      var trustpilotWidgetScript=document.createElement('script');trustpilotWidgetScript.src='https\:\/\/widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';document.head.appendChild(trustpilotWidgetScript)
    ">
  

</body></html>
        `);
        iframe.contentWindow.document.close();
      }
    }
  },
    {
    content: `<iframe id="iframe3" name="iframe3" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" scrolling="auto" data-ready="1"></iframe>`,
    type: 'html',
    afterShow: function(instance, current) {
      const iframe = document.getElementById('iframe3');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(`
          <html><head>
          <script type="text/javascript" crossorigin="anonymous" src="https://bpi.zip.co/assets/js/amplitude-8.16.1-min.gz.js"><\/script>
          <script src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/zip-modal-script.js"><\/script>
          <script src="https://static.zipmoney.com.au/lib/js/zm-calculator/zip.money.calculator.min.js"><\/script>
          <script src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"><\/script>
          <script src="https://bpi.zip.co/assets/primary/resources/amplitude/amplitude-injector.js" type="text/javascript"><\/script>
          </head><body>

    <meta charset="utf-8">
    <style>
      @font-face {
          font-weight:500;
          font-family:"Jug Sharp Grotesk 25";
          font-style: normal; 
          src: local("Jug Sharp Grotesk 25"), local("Jug Sharp Grotesk 25");
          src: url("https://bpi.zip.co/assets/fonts/sharp-grotesk-semibold-25.woff2") format("woff2");
          font-display: swap;
      }
      
      :root {
        /* Calculator */
        --zm-calculator-width: ***px;
        /*Margins */
        margin-left: auto;
        margin-right: auto;
        /* Fonts */
        --sharp-grotesk-font: Sharp Grotesk, Helvetica;
        --sharp-grotesk-font-wide: 'Sharp Grotesk 25';
        --sharp-grotesk-jug: 'Jug Sharp Grotesk 25';
        --weight-book: 400;
        --weight-medium: 500;
        background-color: #F6F6EE;
        overflow-x: hidden;
      }

      html {
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none; 
      }

      html::-webkit-scrollbar { 
        display: none;  /* Safari and Chrome */
      }

      .zip-logo {
        width:62.67px;
        height:24px;
        margin-bottom: 16px;
      }
      .zm-details {
        height: 100%;
        width: 100%;
        border-color: transparent;
        display: grid;
        color: #1a0826;
      }
      .header {
        display: grid;
        margin: -2%;
        margin-bottom: 2%;
      }
      .pocket {
        background-color: #AA8FFF;
        position:absolute;
        right: -1rem;
        top: 0;
        height: calc(100% + 5%);
        width: calc(75%);
        clip-path: polygon(100% 100%, 70% 100%, 60% 0, 100% 0);
      }
      .hero-banner {
        position: relative;
        background-color: #1a0826;
      }
      .container {
        display: grid;
        position: relative;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 1rem; 
      }
      .left-text {
        margin: 16% 30% 10% 12%;
        width: 87%;
      }
      .left-text h3 {
        font-weight: 600;
        font-size: 38px;
        line-height: 110%;   
        color:white;
        margin:0;  
        padding-bottom: 20px; 
        font-feature-settings: 'ss01' on, 'ss02' on;  
      }
      .left-text h4 {
        font-weight: var(--weight-medium);            
        font-size: 14px;
        line-height: 130%;
        padding-bottom: 4px;
        font-style: normal;
        color:white;
        margin:0;
        position:relative;
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .left-text p {
        font-weight: var(--weight-book);            
        font-size: 14px;         
        padding-bottom: 5px;
        font-style: normal;
        color:white;
        margin:0;
        position:relative;
        display: flex;
        align-items:center;
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .left-text b {
        font-weight: var(--weight-medium);  
        font-feature-settings: 'ss01' on, 'ss02' on;          
      }
      .app-review {
        margin-top: 16px;
        font-size: 12px;
      }
      #translations-main,
      .trustpilot-widget {
        right: 1.5rem;
        font-weight: var(--weight-book); 
        font-size: 12px !important;    
        margin-bottom: 4%;    
        font-feature-settings: 'ss01' on, 'ss02' on; 
        color: white;
      }
       .right {
        margin-left: auto;
        margin-right: auto;
        position: absolute;
        right: 50px;
        bottom: -70px;
      }
      .zip-account-info {
        box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.14);
        border-radius: 2px;
      }
      .zm-content {
        padding-left: 4%;
        margin-top: 4%;
      }
      .zm-list li {
        background-image: url("https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/bullet-points.svg");
        font-weight: var(--weight-book);
        background-repeat: no-repeat;
        padding-inline-start: 40px;
        display: inline-block;
        font-size: 12px;
        line-height: 150%;
        margin-block-end: 16px;
        list-style-position: outside;
        width: 100%;
        color: #1A0826;
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .zm-list b {
        font-weight: var(--weight-medium);
        font-feature-settings: 'ss01' on, 'ss02' on;
      }
      .section-zip-disclaimer {
        padding: 2% 4% 4% 4%;
        border-color: transparent;
        color: #786E7A;
      }
      .disclaimer-content {
        display: flex;
        font-weight: var(--weight-book);
        font-size: 9px;
        line-height: 140%;
        font-feature-settings: 'ss01' on, 'ss02' on;
        letter-spacing: 0.4px;
      }
      .zm-calculator-mobile,
      .hidden {
        display: none;
      }
      @media screen and (min-width: 145px) {
        .tp-widget-rating, .tp-widget-logo {
          font-weight: var(--weight-book); 
          font-size: 12px !important;    
          font-feature-settings: 'ss01' on, 'ss02' on;
          margin: 0px;
          margin-left: -1px;        
        }
      }
      @media (max-device-width: 640px) { /* MOBILE */
        .pocket {
          height: calc(100% + 5%);
          width: calc(40%);
          clip-path: polygon(100% 100%, 80% 100%, 50% 0, 100% 0);
        }
        .container {
          display: grid;
          position: relative;
          grid-template-columns: repeat(1, 1fr);
          grid-gap: 1rem; 
        }
        .left-text {
          margin: 14% 20% 14% 8%;
          width: 76%;
        }
        .left-text h3 {
          font-size: 34px;
        }
        .left-text h4,
        .left-text p {
          font-size: 16px;
        }
        .app-review {
          font-size: 13px;
        }
        .zm-content {
          padding: 4%;
        }
        .zm-calculator-mobile {
          display: flex;
          width: 100%;
          margin-top: -20%;
          margin-bottom: 4%;
        };
        .zm-list li {
          width: 90%;
          font-size: 16px;
        }
        .disclaimer-content {
          font-size: 11px;
        }
        .right {
          display: none;
        }
      }
      @media (min-device-width: 1300px) {
        .body {
          height: fit-content;
        }
      }
  </style>
    <section class="header">
      <div class="hero-banner">
        <div class="pocket"></div>
        <div class="container">
          <div class="left-text">
            <img class="zip-logo" src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/zip-logo.svg" alt="Zip Logo">
            <h3>The better way to pay</h3>
            <h4>ZIP MONEY</h4>
            <p>Make it easier to pay for big purchases</p>
            <div class="app-review">
              <p><b>4.9</b> 
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-left: 4px; padding-right: 4px;">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px;">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px;">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px;">
                <img src="https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/assets/star.svg" alt="star icon" width="16.03" height="16.03" style="padding-right: 4px;">
                App store rating</p>
            </div>
          </div>
          <div class="right">
            <div class="zip-account-info zip-account-info-calculator">
              <zm-calculator class="zm-calculator" merchant-public-id="{MerchantPublicId}" product-price="{productPrice}" utm-content="zm_modal"></zm-calculator>
            </div>
          </div>
        </div> 
      </div>
    </section>
    <section class="zm-content">
      <zm-calculator class="zm-calculator-mobile" merchant-public-id="{MerchantPublicId}" product-price="{productPrice}" utm-content="zm_modal"></zm-calculator>
      <div class="zm-list">
          <li data-max-credit="max-credit">Apply for <b>$1,000 - $5,000</b></li>
          <li>Pay <b>nothing today</b></li>
          <li data-max-interest="max-interest"><b>3 - 60 months </b> interest free* </li>
          <li><b data-monthly-fee="monthly-fee">$9.95/mth</b> account fee or $0 if nothing owing </li>
          <li><b>One off</b> establishment fee up to $99 may apply </li>
    </div>
    </section>
    <section class="section-zip-disclaimer">
      <span class="disclaimer-content">
        <p>
          *Zip Money. Interest free term subject to minimum spend and promotional partner offer. Available to approved applicants only and subject to completion of satisfactory credit assessment. A monthly account fee of $9.95 applies and a one off establishment fee may apply for new customers. Any balance outstanding at the expiry of the interest free period will be charged at the standard variable interest rate, 25.9% per annum, as at 1 June 2023. Other charges may be payable, see T&amp;Cs. Interest, fees and charges subject to change. Minimum monthly payments are required and vary depending on credit limit. Paying only the minimum monthly repayment may not repay a purchase within the interest free period. Paying the minimum monthly repayment may result in paying off the purchase before the interest free period expires. Credit provided by ZipMoney Payments Pty Ltd (ABN 58 164 440 993), Australian Credit Licence Number 441878. Terms &amp; Conditions apply and are available on application. See your contract for further details.
        </p>
      </span>
    </section>
    <img id="helper" class="hidden" src="null" data-amp-page="zip_merchant_modal_zip_money" onerror="var script=document.createElement('script');script.src='https://bpi.zip.co/assets/primary/entrypoints/consumer/modal/zip-modal-script.js';document.head.appendChild(script);
      var zmCalculatorScript=document.createElement('script');zmCalculatorScript.src='https\:\/\/static.zipmoney.com.au/lib/js/zm-calculator/zip.money.calculator.min.js';document.head.appendChild(zmCalculatorScript)
      var trustpilotWidgetScript=document.createElement('script');trustpilotWidgetScript.src='https\:\/\/widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';document.head.appendChild(trustpilotWidgetScript)
    ">    
  
</body></html>
        `);
        iframe.contentWindow.document.close();
      }
    }
  },
      ], {
        width: "100%",
        maxWidth: "800px",
        height: 575,
        scrolling: 'auto',
        fitToView: false,
        autoSize: false,
        iframe: {
          scrolling: 'auto',
          preload: false
        },
        afterShow: function () {
          $('.fancybox-iframe').attr({
            allowfullscreen: true,
            frameborder: 0,
            scrolling: 'auto'
          });
        }
      });
    });
  });
